"use client";
import MemeCoinsFilter from "./MemeCoinsFilter";
import MemeCoinsSection from "./MemeCoinsSection";
import MemeCoinsPagination from "./MemeCoinsPagination";
import type { TokenDataType } from "@/utils/types";
import { useRouter, useSearchParams } from "next/navigation";
import { useTransition } from "react";
import CoinCardSkeleton from "../ui/card/coinCardSkeleton";
import Link from "next/link";

export default function MemeCoins({
  tokenData,
  isHome,
}: {
  tokenData: TokenDataType;
  isHome?: boolean;
}) {
  const searchParams = useSearchParams();
  const [isPending, startTransition] = useTransition();
  const sortBy = searchParams.get("sortBy") || "createdAt";
  const router = useRouter();

  const handleFilterChange = (filter: string) => {
    startTransition(() => {
      const params = new URLSearchParams(searchParams);
      params.set("sortBy", filter);
      router.push(`?${params.toString()}`, { scroll: false });
    });
  };
  return (
    <main className="mt-16">
      <div className="text-center mb-[32px]">
        <h3 className="bg-clip-text text-transparent bg-gradient-to-r from-white to-white/70 md:text-[56px] text-2xl font-bold mb-4">
          Explore Latest Meme Coins
        </h3>
        <p className="md:text-base text-xs text-gray-400 max-w-3xl mx-auto">
          Explore trending meme coins, analyze their performance, and connect
          with the communities behind them. Filter tokens by liquidity, market
          cap, popularity, and more.
        </p>
      </div>
      <div className="bg-[#100F17] border-2 border-primaryborder rounded-[20px] p-6">
        <MemeCoinsFilter onFilterChange={handleFilterChange} sortBy={sortBy} />
        {isPending ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[1, 2, 3, 4, 5, 6].map((coin) => (
              <CoinCardSkeleton key={coin} />
            ))}
          </div>
        ) : (
          <MemeCoinsSection tokenData={tokenData} />
        )}
        {isHome ? (
          <div className=" text-lg mt-6 mb-4 flex items-center justify-center">
            <Link
              href={"/explore"}
              className="bg-[#013B98] text-white border-[#013B98] shadow-[0_0_12px_#013B98] hover:scale-[99%] hover:opacity-80 border transition-all duration-300 px-6 py-2 rounded-full text-base"
            >
              Explore More!
            </Link>
          </div>
        ) : (
          <MemeCoinsPagination pagination={tokenData.pagination} />
        )}
      </div>
    </main>
  );
}
